import { environment } from '../../../environments/environment';


export function getUrl(path: string) {    
    return `${environment.api}${path}`;
}

export const env = ()=>{
    return environment;
}

export const getAppLang = () => {
    let lang = 'en-US';
    try {
        lang = localStorage.getItem('app_lang') || 'en-US';
    } catch (error) {
        console.log(">>>> src/app/utils/util.js : getAppLang -> error", error)
        lang = 'en-US'
    }
    return lang;
}
export const setAppLang = (lang:string) => {
    try {
        localStorage.setItem('app_lang', lang);
    } catch (error) {
        console.log(">>>> src/app/utils/util.js : setAppLang -> error", lang)
    }
}